 /****-------------------------------------------on clicking of reviews redirecting to reviews section-------------------------------------------****/
 
 function smoothScrollTo(element, duration = 1000, offset = 150) {
    const target = typeof element === 'string' ? document.querySelector(element) : element;
    if (!target) return;
    const start = window.scrollY || window.pageYOffset;
    // Subtract offset from the final scroll position
    const end = target.getBoundingClientRect().top + start - offset;
    const change = end - start;
    const startTime = performance.now();

    function animateScroll(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      // Ease in-out
      const ease = progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;
      window.scrollTo(0, start + change * ease);
      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      }
    }
    requestAnimationFrame(animateScroll);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var reviewBtns = document.querySelectorAll('.clickable_review');
    var reviewSection = document.getElementById('allReviews');
    if (reviewBtns.length && reviewSection) {
      reviewBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          smoothScrollTo(reviewSection, 1000, 150); // 2 seconds, 150px offset
        });
      });
    }
  });
  


  /****-------------------------------------------quantity update and variant selection-------------------------------------------****/
  
  function rebindBulkBuyEvents() {
  document.addEventListener('click', function (event) {
    // Check if the clicked element (or one of its ancestors) matches 'label.bulk-buy'
    const label = event.target.closest('label.bulk-buy');
    
    // If not a bulk-buy label, do nothing
    if (!label) return;
    
    // Get the quantity attribute
    const qty = label.getAttribute('data-qty');

    // Call updatePriceDisplay if it exists
    if (typeof window.updatePriceDisplay === 'function') {
      window.updatePriceDisplay(qty);
    } else {
      console.warn("updatePriceDisplay not defined when label clicked");
    }
  });
}

rebindBulkBuyEvents();

window.updatePriceDisplay = function (Value) {
    if (isNaN(Value) || Value <= 0) {
        console.warn('Invalid quantity:', Value);
        return;
    }

    const mainAddToBasketContainer = document.querySelector('.main-add-to-basket');
    const priceSections = document.querySelectorAll('.price_quantity_wrapper .price__container, product-info .price__container, .main-add-to-basket .price__container');

    const discountTwo = mainAddToBasketContainer ? Number(mainAddToBasketContainer.getAttribute('data-discount-two')) || 0 : 0;
    const discountThree = mainAddToBasketContainer ? Number(mainAddToBasketContainer.getAttribute('data-discount-three')) || 0 : 0;

    const updateQuantityInputs = (Value) => {
        document.querySelectorAll('.price_quantity_wrapper .quantity__input').forEach(input => input.value = Value);
        document.querySelectorAll('.updated-product-quantity').forEach(input => input.setAttribute("value", Value));
        document.querySelectorAll('.price-per-item__container .quantity__button').forEach(button => {
           if (Value >= 2) {
            button.classList.remove('disabled');
          }
        });
    };

    const getDiscountedPrice = (regularPrice, Value) => {
        if (Value > 1 && Value < 3) return regularPrice * (1 - discountTwo / 100);
        if (Value > 2) return regularPrice * (1 - discountThree / 100);
        return regularPrice;
    };
    const checkedInput = document.querySelector('variant-selects input[type="radio"]:checked');
    const bulkBuy = document.querySelector('.main-bulk-buy');
    if (checkedInput && !bulkBuy) {
      let productWrapper = checkedInput.closest(".product__info-wrapper"); 
      let priceContainer = productWrapper.querySelector(".price__container");
      let selectedVariantPrice = parseFloat(checkedInput.getAttribute("product-option-variant-price")) / 100;
      let selectedVariantMrp = parseFloat(checkedInput.getAttribute("product-option-variant-mrp")) / 100;
      // alert(priceContainer.value);
      if (selectedVariantPrice && selectedVariantMrp > selectedVariantPrice) {
        priceContainer.innerHTML = ` <span class="price-item price-item--sale price-item--last">${formatPrice(selectedVariantPrice * Value)}</span>
        <s class="price-item price-item--compare price-item--regular">${formatPrice(selectedVariantMrp * Value)}</s>`
      } else {
        priceContainer.innerHTML = ` <span class="price-item price-item--sale price-item--last">${formatPrice(selectedVariantPrice * Value)}</span>`  
      }

      const totalRegularPrice = getProductPriceBasedOnQuantity(Value, selectedVariantPrice);
      // Update comfort points based on discounted or regular price
      updateCustomerPoints(Value, totalRegularPrice, totalRegularPrice);
    } else {

      priceSections.forEach(priceContainer => {
        const regularPrice = parseFloat(priceContainer.getAttribute('data-regular-price')) / 100;
        const compareAtPrice = parseFloat(priceContainer.getAttribute('data-compare-price')) / 100;

        const hasBulkDiscount = mainAddToBasketContainer && (
          mainAddToBasketContainer.hasAttribute('data-discount-two') ||
          mainAddToBasketContainer.hasAttribute('data-discount-three')
        );

        // Retrieve the stored flag from sessionStorage
        const xvdStored = sessionStorage.getItem('xvd_found');

        let isBulkApplicable;

        if (xvdStored === 'true') {
          // xvd was detected earlier in the session
          isBulkApplicable = false;
        } else {
          // Normal bulk logic
          isBulkApplicable = Value > 1 && hasBulkDiscount;
        }

        const totalRegularPrice = getProductPriceBasedOnQuantity(Value, regularPrice);

        let totalCompareAtPrice;
        if (isBulkApplicable) {
            // When bulk discount is applied, compare-at = base price * qty
            totalCompareAtPrice = compareAtPrice ? getProductPriceBasedOnQuantity(Value, regularPrice) : null;
        } else {
            // Else, use actual compare-at * qty
            totalCompareAtPrice = compareAtPrice ? getProductPriceBasedOnQuantity(Value, compareAtPrice) : null;
        }

        let finalPrice = totalRegularPrice;
        if (isBulkApplicable) {
            finalPrice = getDiscountedPrice(totalRegularPrice, Value);
        }

        priceContainer.innerHTML = '';

        if (Value == 1) {
          // Handle quantity = 1
          if (compareAtPrice && compareAtPrice > regularPrice) {
            priceContainer.innerHTML = `
              <span class="price-item price-item--sale price-item--last">${formatPrice(regularPrice)}</span>
              <s class="price-item price-item--compare price-item--regular">${formatPrice(compareAtPrice)}</s>
            `;
          } else {
            priceContainer.innerHTML = `
              <div class="price__regular">
                <span class="price-item price-item--regular">${formatPrice(regularPrice)}</span>
              </div>
            `;
          }
        } else if (Value > 1 && totalCompareAtPrice) {
          // Show compare-at and regular for quantity > 1
          priceContainer.innerHTML = `
            <span class="price-item price-item--sale price-item--last">${formatPrice(finalPrice)}</span>
            <s class="price-item price-item--compare price-item--regular">${formatPrice(totalCompareAtPrice)}</s>
          `;
        } else if (finalPrice < totalRegularPrice) {
          // Discounted without compare-at
          priceContainer.innerHTML = `
            <span class="price-item price-item--sale price-item--last">${formatPrice(finalPrice)}</span>
            <s class="price-item price-item--regular">${formatPrice(totalRegularPrice)}</s>
          `;
        } else {
          // No discount or compare-at
          if (finalPrice != totalRegularPrice) {
            priceContainer.innerHTML = `
              <div class="price__regular">
                <span class="price-item price-item--regular">${formatPrice(finalPrice)}</span>
                <s class="cc price-item price-item--regular">${formatPrice(totalRegularPrice)}</s>
              </div>
            `;
          } else {
            priceContainer.innerHTML = `
              <div class="price__regular">
                <span class="price-item price-item--regular">${formatPrice(finalPrice)}</span>
              </div>
            `;
          }
        }

        // Update comfort points based on discounted or regular price
        updateCustomerPoints(Value, totalRegularPrice, finalPrice);

        updateQuantityInputs(Value);
      });
    }
};

function formatPrice(price) {
    // Ensure two decimals, then swap . and ,
    let parts = price.toFixed(2).split('.');
    let integerPart = parts[0];
    let decimalPart = parts[1];
    // Add thousands separator (.)
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    // Join with comma as decimal separator
  return `${integerPart},${decimalPart}€`;
}

function getProductPriceBasedOnQuantity(Value, unitPrice) {
    return unitPrice * Value;
}

function updateCustomerPoints(Value, totalRegularPrice, finalPrice) {
  const customerPointsElement = document.getElementById('comfortPoints');
  // Use the discounted price if there is a discount, else use the regular price
  let priceToUse = (finalPrice < totalRegularPrice) ? finalPrice : totalRegularPrice;
  let updatedPrice = priceToUse; // Convert from cents to euros
  const ceilCustomerPoints = Math.floor(updatedPrice);
  if (customerPointsElement) {
      customerPointsElement.innerText = `${ceilCustomerPoints}`;
  }
}

// Function to update comfort points based on bulk buy //
document.addEventListener('DOMContentLoaded', function() {
    const customerPointsElement = document.getElementById('comfortPoints');
    const bulkBuyInputs = document.querySelectorAll('.bulkbuy-input-element');
    if(bulkBuyInputs){
      bulkBuyInputs.forEach(input => {
        input.addEventListener('change', function() {
          const points = this.getAttribute('data-points');
          if (customerPointsElement) {
            customerPointsElement.innerText = `${points}`;
          }
        });
      });
    }
    rebindBulkBuyEvents();
});


/***variant Updation code */
let lastUrl = location.href;
function highlightVariantImage() {
  const variantSelects = document.querySelector("variant-selects, .variant-selects");
  if (!variantSelects) return;

  const checkedInput = variantSelects.querySelector("input[type='radio']:checked");
  if (!checkedInput) return;

  const selectedValue = checkedInput.value.trim();
  if (!selectedValue) return;

  // Remove old highlights
  document.querySelectorAll(".variant-image-found").forEach(el =>
    el.classList.remove("variant-image-found")
  );

  // Highlight elements directly matching via data attributes
  const matchingElements = document.querySelectorAll("[data-variant-thumbnail-alt], [data-media-variant]");
  matchingElements.forEach(el => {
    const alt = el.getAttribute("data-variant-thumbnail-alt") || "";
    const media = el.getAttribute("data-media-variant") || "";
    if (alt.includes(selectedValue) || media.includes(selectedValue)) {
      el.classList.add("variant-image-found");
    }
  });

  // Highlight closest .owl-item for each .media_modal_wrapper
  document.querySelectorAll(".media_modal_wrapper").forEach(wrapper => {
    const variantAlt = wrapper.getAttribute("data-variant-thumbnail-alt") || "";
    const owlItem = wrapper.closest(".owl-item");

    if (!owlItem) return;

    if (variantAlt.includes(selectedValue)) {
      owlItem.classList.add("variant-image-found");
    } else {
      owlItem.classList.remove("variant-image-found");
    }
  });
}

window.refreshScrollingAt = function () {
  const url = window.location.href;

  fetch(url)
    .then(response => response.text())
    .then(html => {
      const tempDOM = document.createElement('div');
      tempDOM.innerHTML = html;

      const newBulkBuyatc = tempDOM.querySelector('.product__media-wrapper');
      const currentBulkBuyatc = document.querySelector('.product__media-wrapper');

      const newMediaModal = tempDOM.querySelector('.product-media-modal__dialog');
      const currentMediaModal = document.querySelector('.product-media-modal__dialog');

      if (newBulkBuyatc && currentBulkBuyatc)
        currentBulkBuyatc.innerHTML = newBulkBuyatc.innerHTML;

      if (newMediaModal && currentMediaModal)
        currentMediaModal.innerHTML = newMediaModal.innerHTML;

      // ✅ Reinitialize Owl Carousel AFTER DOM is updated
      window.initializeOwlCarousel(); // 👈 Your custom init function
    })
    .catch(err => {
      console.error('Failed to refresh BULK BUY or SCROLLING BAR:', err);
    });
};


// Toggle visibility of bulk-buy options based on selected variant
function toggleBulkBuyVisibilityAndSelectFirst(e, targetID) {
  const el = e?.target || e;
  if (!el || !(el instanceof Element)) return;

  // Only respond to checked input
  if (el.tagName === 'INPUT' && !el.checked) return;

  const checkedInputvariantId = targetID;
  const wrapper = el.closest('.product__info-wrapper') || document;

  let firstVisibleBulkBuy = null;

  wrapper.querySelectorAll('.bulk-buy-inner').forEach(inner => {
    const bulkBuyVariantId = inner.getAttribute('data-variant-bulk-id')?.trim();

    if (checkedInputvariantId === bulkBuyVariantId) {
      inner.classList.remove("hidden");
      if (!firstVisibleBulkBuy) firstVisibleBulkBuy = inner;
    } else {
      inner.classList.add("hidden");
    }
  });

  // Select the first input inside the first visible bulk-buy-inner
  if (firstVisibleBulkBuy) {
    const firstInput = firstVisibleBulkBuy.querySelector('input[type="radio"], input[type="checkbox"]');
    if (firstInput) {
      firstInput.checked = true;
      // Optionally, trigger change event if your logic depends on it
      firstInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  highlightVariantImage();
  //refreshScrollingAtc();
  rebindBulkBuyEvents();
}

// Auto-run on page load
document.addEventListener('DOMContentLoaded', () => {
  // Trigger bulk-buy visibility if variant is pre-selected
  const checkedInput = document.querySelector('variant-selects input[type="radio"]:checked');
  console.log("checkedInput" , checkedInput);
  if (checkedInput) {
    
    const variantId = checkedInput.getAttribute('product-option-variant-id');
    console.log("variantId",variantId);
    toggleBulkBuyVisibilityAndSelectFirst(checkedInput, variantId);
  } else {
    console.warn("❌ No variant is checked on page load.");
  }

  // Run other variant-related logic
  if (
    location.href.includes('/products/') &&
    document.body.classList.contains('body-has-variants')
  ) {
    window.runVariantUpdateLogic?.();
  }

  setTimeout(() => {
    rebindBulkBuyEvents();
  }, 300);
});

// On URL change, re-run variant logic
const observer = new MutationObserver(() => {
  const currentUrl = location.href;
  if (currentUrl !== lastUrl) {
    lastUrl = currentUrl;
    window.runVariantUpdateLogic?.();
  }
});
observer.observe(document.body, { childList: true, subtree: true });

// Product Reviews 
const reviewElement = document.querySelectorAll('#goAllReviews');

reviewElement?.forEach((each) => {
  each.addEventListener('click', (event) => {
    event.preventDefault();
    const reviewHref = each.getAttribute('href');
    const reviewWrapper = document.querySelector(reviewHref);  
    if (reviewWrapper) {
      smoothScrollToElement(reviewWrapper, 160)
    }
  });
})

function smoothScrollToElement(element, offset = 0) {
  const elementRect = element.getBoundingClientRect();
  const absoluteElementTop = elementRect.top + window.pageYOffset;
  const scrollPosition = absoluteElementTop - offset;
  
  window.scrollTo({
    top: scrollPosition,
    behavior: 'smooth'
  });
}

// Mega sale
// NOTE: this file is a lazy-script that runs AFTER DOMContentLoaded, so a plain
// DCL listener never fires. Use the readyState pattern (run now if DOM is ready).
(function () {
  function initMegaSale() {
  document.querySelectorAll('.mega-sale-copy-button').forEach(function (button) {

    button.addEventListener('click', function () {
      const discountCode = this.dataset.discountCode;
      const tooltip = this.querySelector('.tooltiptext');

      if (!discountCode) return;

      // Copy to clipboard
      navigator.clipboard.writeText(discountCode).then(() => {
        // Show tooltip
        tooltip.classList.add('active');

        // Hide tooltip after 2 seconds
        setTimeout(() => {
          tooltip.classList.remove('active');
        }, 2000);
      });
    });

  });
  const knowMoreButton = document.querySelector('#mega_sale_know_more');
  const megaSaleCloseButton = document.querySelector('.mega-sale-close-button')
  const offerBoxContent = document.querySelector('#know_more_content');
  const offerBox = document.querySelector('.offer-box__container');
  knowMoreButton?.addEventListener('click', () => {
    if (offerBox) offerBox.classList.add('hidden');
    if (offerBoxContent) offerBoxContent.classList.remove('hidden');
  })

  megaSaleCloseButton?.addEventListener('click', () => {
    if (offerBox) offerBox.classList.remove('hidden');
    if (offerBoxContent) offerBoxContent.classList.add('hidden');
  })

  window.updateMegaSalePrice = function(value) {
    const megaSaleBox = document.querySelector('.mega-sale__offer_box');
    if (megaSaleBox) {
      const megaSalePrice = parseFloat(megaSaleBox.getAttribute('data-discounted-price'));
      const originalPrice = parseFloat(megaSaleBox.getAttribute('data-original-price'));
      const megaSalePriceElement = megaSaleBox?.querySelectorAll('.mega-sale-price');
      const megaSaleSavePriceElement = megaSaleBox?.querySelector('.mega-sale-extra-saving-price');

      const totalOriginalPrice = (originalPrice * value) / 100
      const discountedPrice = (megaSalePrice * value) / 100

      const savedPrice = totalOriginalPrice - discountedPrice
      const totalSaved = savedPrice
      const finalSavedAmount = formatPrice(totalSaved);
      const finalDiscountedPrice = formatPrice(discountedPrice);
      megaSalePriceElement?.forEach((each)=> each.textContent = finalDiscountedPrice);
      megaSaleSavePriceElement.textContent = finalSavedAmount;
      console.log(finalDiscountedPrice);
    }
  }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaSale);
  } else {
    initMegaSale();
  }
})();
// custom BUY NOW JS
// NOTE: this file is a lazy-script that runs on first user interaction, which
// is AFTER DOMContentLoaded has fired. A plain DCL listener would never run,
// so we run now if the DOM is already ready, otherwise wait for DCL.
(function () {
  function initBuyNow() {
  document.querySelectorAll('[id^="BuyNowButton-"]').forEach(button => {
    button.addEventListener("click", async function () {
      const productForm = button.closest('product-form');
      const form = productForm?.querySelector('form');

      if (!form) return;

      button.setAttribute('disabled', true);

      const formData = new FormData(form);

      try {
        // Add product to cart
        await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        // Get updated cart
        const cartResponse = await fetch('/cart.js');
        const cartState = await cartResponse.json();

      
        if (typeof window !== "undefined" && typeof window.handleGiftProduct === "function") {
          await window.handleGiftProduct(cartState);
        } else {
          console.warn("handleGiftProduct not found → skipping");
        }

      } catch (err) {
        console.error('Buy Now error:', err);
      } finally {
       
        window.location.href = '/checkout';
      }
    });
  });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuyNow);
  } else {
    initBuyNow();
  }
})();


/**---------------------------------------------------------------ugc custom slider -----------------------------------------------*/
(function () {
  var ugcWidget = document.getElementById('ugcWidgetMain');
  if (!ugcWidget) return;

  function ready() {
    return window.jQuery && jQuery.fn && jQuery.fn.owlCarousel;
  }
  function initUgc() {
    jQuery(ugcWidget)
      .owlCarousel({ loop: false, nav: false, dots: false, autoWidth: true, margin: 14 })
      .on('initialized.owl.carousel', function () {
        jQuery(ugcWidget).removeClass('ugc-loading');
      });
  }

  // jQuery is async + owl is a lazy-script, so they may not be ready yet. Init now
  // if ready, else poll until owl is available — instead of throwing.
  if (ready()) {
    initUgc();
    return;
  }
  var t = setInterval(function () {
    if (ready()) {
      clearInterval(t);
      initUgc();
    }
  }, 200);
  setTimeout(function () {
    clearInterval(t);
  }, 15000);
})();


// Frequently Bought Together (moved from product-fbt.liquid). Lazy-script runs
// after DOMContentLoaded, so use the readyState pattern; guarded to no-op off-page.
(function () {
  function initFbt() {
    const submitButton = document.querySelector('#ATCFBT');
    const fbtGrid = document.querySelector('.fbt-grid');
    if (!submitButton || !fbtGrid) return; // FBT not present on this page

    const checkboxes = document.querySelectorAll('.input_checkbox'),
      addOnQtyElement = document.getElementById('addOnQty'),
      addOnPriceElement = document.getElementById('addOnPrice'),
      sugestedTotPriceElement = document.getElementById('sugestedTotPriceDesktop'),
      currencySymbol = document.querySelector('header')?.getAttribute('data-currency-symbol') || '$',
      firstProductElement = document.querySelector('.first-product'),
      firstProductPrice = firstProductElement
        ? parseFloat(firstProductElement.getAttribute('data-price-fbt')) || 0
        : 0;

    const getProductDataFromElement = (checkbox) => {
      const parentElement = checkbox.closest('.addons_product');
      return parentElement
        ? {
            productId: parentElement.getAttribute('data-fbt-id'),
            priceFbt: parseFloat(parentElement.getAttribute('data-price-fbt')) || 0,
          }
        : { productId: null, priceFbt: 0 };
    };

    const getCheckedProductIds = () => {
      const productVarIds = [
        firstProductElement ? Number(firstProductElement.getAttribute('data-fbt-id')) : null,
      ].filter(Boolean);
      checkboxes.forEach((checkbox) => {
        if (checkbox.checked) {
          const { productId } = getProductDataFromElement(checkbox);
          productVarIds.push(Number(productId)); // Ensure all IDs are numbers
        }
      });
      return productVarIds;
    };

    const updateCheckedProducts = () => {
      let totalCheckedQty = 0,
        totalPrice = 0;
      checkboxes.forEach((checkbox) => {
        if (checkbox.checked) {
          const { priceFbt } = getProductDataFromElement(checkbox);
          totalCheckedQty++;
          totalPrice += priceFbt;
        }
      });

      fbtGrid?.classList.toggle('no-checked-product', totalCheckedQty === 0);
      addOnQtyElement.textContent = totalCheckedQty;
      addOnQtyElement.parentElement.style.display = totalCheckedQty ? 'block' : 'none';

      let formattedTotalPrice = (totalPrice / 100).toFixed(2);
      let formattedSuggestedPrice = ((totalPrice + firstProductPrice) / 100).toFixed(2);

      // Replace dot with comma for decimal separator
      formattedTotalPrice = formattedTotalPrice.replace('.', ',');
      formattedSuggestedPrice = formattedSuggestedPrice.replace('.', ',');

      if (currencySymbol === '€') {
        addOnPriceElement.textContent = `${formattedTotalPrice}${currencySymbol}`;
        sugestedTotPriceElement.textContent = `${formattedSuggestedPrice}${currencySymbol}`;
      } else {
        addOnPriceElement.textContent = `${currencySymbol}${formattedTotalPrice}`;
        sugestedTotPriceElement.textContent = `${currencySymbol}${formattedSuggestedPrice}`;
      }

      const computedPrice = (totalPrice + firstProductPrice) / 100;

      const otherBenefitsElement = document.querySelector('.otherBenefits');

      // Check the condition and toggle the hidden class
      if (computedPrice < 50) {
        otherBenefitsElement.classList.add('hidden');
      } else {
        otherBenefitsElement.classList.remove('hidden');
      }
    };

    updateCheckedProducts();

    fbtGrid?.addEventListener('change', (event) => {
      if (event.target?.classList.contains('input_checkbox')) updateCheckedProducts();
    });

    submitButton.addEventListener('click', () => {
        if (submitButton.disabled) return;

       submitButton.disabled = true;
      const productVarIds = getCheckedProductIds();
      console.log('Product IDs to add to cart:', productVarIds);
      if (productVarIds.length) ajaxCallUpdateCart(productVarIds);
      let headerGroup = document.querySelector('.header');
      const cart_Drawer = document.querySelector('cart-drawer');

      function updateCartDrawerPosition() {
        if (window.innerWidth > 990) {
          if (headerGroup && cart_Drawer) {
            let headerHeight = headerGroup.offsetHeight;
            let headerTop = headerGroup.getBoundingClientRect().top;
            let topValue = headerHeight + headerTop;

            console.log('topValue', topValue, headerHeight, headerTop);
            cart_Drawer.style.top = `${topValue - 15}px`;
          }
        }
      }
      updateCartDrawerPosition();

      window.addEventListener('scroll', updateCartDrawerPosition);
    });

    const ajaxCallUpdateCart = (productVarIds) => {
      const formData = {
        items: productVarIds.map((id) => ({ id, quantity: 1 })),
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      })
        .then(() => {
          $('.header #cart-icon-bubble').load(location.href + ' #cart-icon-bubble');
          $('.header-dropdown_menu #cart-icon-bubble').load(location.href + ' #cart-icon-bubble');

          // Load CartDrawer and THEN run drawer-related logic
          $('#CartDrawer').load(location.href + ' #CartDrawer', function () {
            const drawer = document.querySelector('.drawer');
            const cartDrawer = document.querySelector('cart-drawer');
            const overlay = document.getElementById('CartDrawer-Overlay');

            if (drawer) {
              drawer.classList.remove('is-empty');
              drawer.classList.add('animate', 'active');
            }

            if (overlay && cartDrawer) {
              overlay.addEventListener('click', () => {
                cartDrawer.classList.remove('active');
              });
            }

            submitButton.disabled = false;
          });
        })
        .catch(console.error);
    };
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFbt);
  } else {
    initFbt();
  }
})();


 